import { getMediaTypeGroup } from '@motionelements/core/src/services/catalog.service';

const AI_BANNER_ALLOWED_MEDIA_TYPES = ['video', 'image'];

const state = {
  preFetchedElements: [],
  semanticZeroElements: [],
  filteredElementsCount: 0,
  semanticRatio: 0,
  //
  loading: false,
  showMore: false,
  isPreFetching: false,
  perPage: 50, // 50
  //
  offsetCount: 1,
  offset: 100, // 200
  limit: 1000, // 1000
  //
  repeatN: 0,
  repeatNLimit: 1,
  //
  normalSearchPage: 2,
  normalSearchResultsExhausted: false,
  semanticSearchExhausted: false,
  //
  devMode: false,
  //
  aiBannerShown: false,
  aiBannerShownPage: 3,
};

const actions = {
  // eslint-disable-next-line
  preFetchElements({ state, getters, commit, dispatch, rootState }) {
    console.log('%c =========== preFetchElements STARTED', 'background: orange');
    commit('setIsPreFetching', true);
    return dispatch('search/searchElements', {
      params: {
        semantic_ratio: state.semanticRatio,
        page: state.offsetCount,
        per_page: state.offset,
      },
      infiniteScroll: true,
    }, { root: true })
      // eslint-disable-next-line
      .then(({ data: { data: elements, facets, similaFaces, totalCount } }) => {
        try {
          if (totalCount <= state.offset * state.offsetCount) {
            commit('setSemanticSearchExhausted', true);
          }
          elements.forEach((element) => { element.semantic = state.semanticRatio; });
          console.log('%c =========== preFetchElements PREFETCHED', 'background: orange');
          console.log(state.offsetCount, elements.length);
          // @toDo remove before commit
          // if (state.offsetCount === 3 && state.repeatN < state.repeatNLimit) elements = [];
          //
          const uniquePrefetchedElements = elements
            .filter(({ id }) => ![...rootState.search.elements, ...state.preFetchedElements]
            .map(({ id }) => id)
            .includes(id));
          console.log(uniquePrefetchedElements.map(({ id }) => id));
          if (!uniquePrefetchedElements.length && totalCount > state.offset * state.offsetCount) {
            console.log(`%c ======== NO UNIQUE SEMANTIC ELEMENTS; semanticRatio: ${state.semanticRatio}, page: ${state.offsetCount}, perPage: ${state.offset}`, 'background: red');
            console.log('%c ======== GOING TO PREFETCH MORE SEMANTIC ELEMENTS', 'background: orange');
            commit('setOffsetCount', state.offsetCount + 1);
            dispatch('preFetchElements');
          } else if (!uniquePrefetchedElements.length && totalCount <= state.offset) {
            dispatch('handleNoSemanticResults');
          } else {
            commit('setRepeatN', 0);
            commit('setPreFetchedElements', [...state.preFetchedElements, ...uniquePrefetchedElements]);
            commit('setFilteredElementsCount', elements.length - uniquePrefetchedElements.length);
            //
            if (facets != null) {
              commit('search/setFacets', facets, { root: true });
            }
            if (similaFaces && similaFaces.length) commit('search/setSimilarFaces', similaFaces, { root: true });
            //
            if (state.semanticZeroElements.length < state.perPage && state.offsetCount === 1) {
              dispatch('showMoreElements');
            }
            commit('setOffsetCount', state.offsetCount + 1);
          }
          return uniquePrefetchedElements;
        } catch (err) {
          console.error(err);
          throw err;
        }
      })
      .catch((err) => {
        console.error(err);
        commit('setIsPreFetching', false);
      })
      .finally(() => {
        // console.log('=========== FINALLY ', state.repeatN);
        commit('setIsPreFetching', false);
      });
  },
  handleNoSemanticResults({ state, commit, dispatch }) {
    console.log('========= handle 0 semantic results');
    // commit('reset');
    if (state.repeatN < state.repeatNLimit) {
      commit('increaseRepeatN');
      console.log(`%c ========== REPEAT ${state.repeatN}`, 'background: green');
      dispatch('preFetchElements');
    }
  },
  // eslint-disable-next-line
  normalSearch({ state, commit, dispatch, rootState }) {
    commit('setLoading', true);
    dispatch('search/searchElements', {
      params: {
        semantic_ratio: 0,
        page: state.normalSearchPage,
        per_page: state.perPage,
      },
      infiniteScroll: true,
    }, { root: true })
      .then((response) => {
        console.log(response);
        if (response.data.data) {
          if (response.data.totalCount <= state.perPage * state.normalSearchPage) {
            commit('setNormalSearchResultsExhausted', true);
          }
          commit('setNormalSearchPage', state.normalSearchPage + 1);
          const uniqElements = response.data.data.filter(({ id }) => ![...rootState.search.elements, ...state.preFetchedElements].map(({ id }) => id).includes(id));
          uniqElements.forEach((element) => { element.semantic = 0; });
          // const elements = [...rootState.search.elements, ...response.data.data];
          // commit('search/setElements', elements, { root: true });
          if (uniqElements.length) {
            const elements = [...rootState.search.elements, ...uniqElements];
            commit('search/setElements', elements, { root: true });
          } else {
            console.log('%c ========= NO UNIQ ELEMENTS in normalSearch', 'background: red');
            console.log('==== preFetchedElements ', state.preFetchedElements.length);
            if (state.preFetchedElements.length) {
              dispatch('showMoreElements');
            } else if (!state.normalSearchResultsExhausted) {
              dispatch('normalSearch');
            }
          }
        }
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  // eslint-disable-next-line
  showMoreElements({ state, commit, dispatch, rootState }) {
    if (state.preFetchedElements.length) {
      const n = state.preFetchedElements.length >= 50 ? 50 : state.preFetchedElements.length;
      const elementsToAdd = state.preFetchedElements.slice(0, n);
      const preFetchedElements = state.preFetchedElements.slice(n);
      console.log('=========== elementsToAdd ', elementsToAdd.map(({ id }) => id));
      console.log(preFetchedElements.map(({ id }) => id));
      commit('setPreFetchedElements', preFetchedElements);
      if (
        !state.aiBannerShown
        && rootState.search.elements.length >= state.perPage * state.aiBannerShownPage
        && AI_BANNER_ALLOWED_MEDIA_TYPES.includes(getMediaTypeGroup(rootState.search.mediaType))
      ) {
        elementsToAdd.unshift({ object: 'banner' });
        commit('setAiBannerShown', true);
      }
      const elements = [...rootState.search.elements, ...elementsToAdd];
      commit('search/setElements', elements, { root: true });
      if (preFetchedElements.length < 50 && !state.semanticSearchExhausted) {
        dispatch('preFetchElements');
      }
    } else if (!state.normalSearchResultsExhausted) {
      console.log(`%c ========== NORMAL SEARCH page:${state.normalSearchPage}`);
      dispatch('normalSearch');
    }
  },
};

const mutations = {
  setPreFetchedElements(state, elements) {
    // console.log('========== setPreFetchedElements ', elements);
    state.preFetchedElements = elements;
  },
  setFilteredElementsCount(state, count) {
    state.filteredElementsCount = count;
  },
  setSemanticZeroElements(state, array) {
    state.semanticZeroElements = array;
  },
  setIsPreFetching(state, boolean) {
    state.isPreFetching = boolean;
  },
  setSemanticRatio(state, number) {
    state.semanticRatio = number;
  },
  setShowMore(state, boolean) {
    state.showMore = boolean;
  },
  setOffsetCount(state, number) {
    state.offsetCount = number;
  },
  reset(state) {
    console.log('%c ============== RESET infiniteScroll', 'background: yellow; color: black');
    state.preFetchedElements = [];
    state.semanticZeroElements = [];
    state.filteredElementsCount = 0;
    state.semanticRatio = 0;
    state.showMore = false;
    state.isPreFetching = false;
    state.offsetCount = 1;
    //
    state.repeatN = 0;
    //
    state.normalSearchPage = 2;
    state.normalSearchResultsExhausted = false;
    state.semanticSearchExhausted = false;
  },
  //
  increaseRepeatN(state) {
    state.repeatN += 1;
  },
  setRepeatN(state, number) {
    state.repeatN = number;
  },
  //
  setLoading(state, boolean) {
    state.loading = boolean;
  },
  setNormalSearchPage(state, number) {
    state.normalSearchPage = number;
  },
  setNormalSearchResultsExhausted(state, boolean) {
    state.normalSearchResultsExhausted = boolean;
  },
  setSemanticSearchExhausted(state, boolean) {
    state.semanticSearchExhausted = boolean;
  },
  //
  switchDevMode(state) {
    state.devMode = !state.devMode;
  },
  //
  setAiBannerShown(state, boolean) {
    state.aiBannerShown = boolean;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
